(function() {
  /* La identidad ya no es el username en claro: es el valor firmado que emite
     CardVault (ADR 216). `vault-identidad.js` la consigue y la renueva. */
  var VAULT = window.VaultIdentidad;
  var CARDVAULT_ORIGIN = VAULT.origen;
  var API_BASE = CARDVAULT_ORIGIN + '/api/wishlist';

  function getVaultUser() {
    return VAULT.usuarioVisible();
  }

  /**
   * Pone TODOS los botones de un producto en el mismo estado.
   *
   * Hace falta desde que las cintas del home existen: cada una lleva su
   * contenido dos veces para que el ciclo no tenga costura, así que la misma
   * carta tiene dos corazones. Sin esto, das like en una copia y la otra sigue
   * apagada — y como la cinta da la vuelta cada minuto y medio, la copia sin
   * marcar acaba entrando en pantalla y parece que el like se perdió.
   */
  function sincronizar(productId, activo) {
    var label = activo ? 'Quitar de wishlist' : 'Agregar a wishlist';
    document.querySelectorAll('.vault-wishlist-btn[data-wishlist-product-id="' + productId + '"]')
      .forEach(function(otro) {
        otro.classList.toggle('is-active', activo);
        otro.setAttribute('aria-label', label);
        otro.setAttribute('title', label);
      });
  }

  function initWishlistButtons() {
    var user = getVaultUser();
    var buttons = document.querySelectorAll('.vault-wishlist-btn');
    if (!buttons.length) return;

    // If logged in, check which products are in wishlist
    if (user) {
      var productIds = [];
      buttons.forEach(function(btn) {
        var pid = btn.getAttribute('data-wishlist-product-id');
        if (pid && productIds.indexOf(pid) === -1) productIds.push(pid);
      });

      if (productIds.length) {
        VAULT.asegurar().then(function() {
          return fetch(API_BASE + '/check', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ shopify_product_ids: productIds })
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(map) {
          buttons.forEach(function(btn) {
            var pid = btn.getAttribute('data-wishlist-product-id');
            if (map[pid]) sincronizar(pid, true);
          });
        })
        .catch(function() {});
      }
    }

    // Attach click handlers. El guard evita duplicarlos: esto corre en
    // DOMContentLoaded y otra vez en cada `shopify:section:load`, y un botón con
    // dos handlers dispara dos toggles y deja el corazón como estaba.
    buttons.forEach(function(btn) {
      if (btn.dataset.vaultWishlistListo) return;
      btn.dataset.vaultWishlistListo = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handleToggle(btn);
      });
    });
  }

  function handleToggle(btn) {
    var user = getVaultUser();
    if (!user) {
      window.location.href = CARDVAULT_ORIGIN + '/login';
      return;
    }

    if (btn.classList.contains('is-loading')) return;

    var wasActive = btn.classList.contains('is-active');
    var productId = btn.getAttribute('data-wishlist-product-id');
    btn.classList.add('is-loading');
    sincronizar(productId, !wasActive);

    // Normalize Shopify image URL to the canonical Shopify CDN so it works regardless
    // of origin. In prod, image_url is protocol-relative (//{shop}.myshopify.com/cdn/shop/...).
    // In dev, the Shopify CLI proxy serves /cdn/shop/... on a local host/port that only
    // works inside the proxy — rewrite those to the permanent myshopify CDN host.
    var SHOPIFY_CDN_HOST = 'https://f34c9b-7b.myshopify.com';
    var imageUrl = btn.getAttribute('data-wishlist-image') || '';
    if (imageUrl) {
      if (imageUrl.indexOf('//') === 0) {
        imageUrl = 'https:' + imageUrl;
      } else {
        var cdnIdx = imageUrl.indexOf('/cdn/shop/');
        if (cdnIdx !== -1 && imageUrl.indexOf('myshopify.com') === -1 && imageUrl.indexOf('cdn.shopify.com') === -1) {
          imageUrl = SHOPIFY_CDN_HOST + imageUrl.slice(cdnIdx);
        }
      }
    }

    /* `asegurar()` se encarga de que el navegador tenga la cookie firmada
       antes del POST. El tema no la ve (es `HttpOnly`) ni la manda a mano: la
       manda el navegador. Si la sesión ya no existe, el POST responde 401 y el
       corazón se revierte solo, como con cualquier otro error. */
    VAULT.asegurar().then(function() {
      return fetch(API_BASE + '/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          card_name: btn.getAttribute('data-wishlist-card-name'),
          shopify_product_id: btn.getAttribute('data-wishlist-product-id'),
          game_type: btn.getAttribute('data-wishlist-game-type'),
          image_url: imageUrl || null,
          current_price: parseFloat(btn.getAttribute('data-wishlist-price')) || null,
          expansion_code: btn.getAttribute('data-wishlist-expansion') || null,
          card_number: btn.getAttribute('data-wishlist-card-number') || null
        })
      });
    })
    .then(function(res) {
      if (!res.ok) throw new Error('API error');
      return res.json();
    })
    .then(function() {
      btn.classList.remove('is-loading');
    })
    .catch(function() {
      // Revert on error — en todas las copias, no solo en la que se tocó.
      btn.classList.remove('is-loading');
      sincronizar(productId, wasActive);
    });
  }

  // Init on DOM ready and after Shopify section renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistButtons);
  } else {
    initWishlistButtons();
  }

  // Re-init when Shopify re-renders sections (AJAX pagination, etc.)
  document.addEventListener('shopify:section:load', initWishlistButtons);
})();
